import { useQueryClient } from "@tanstack/react-query";

import { auditEngagementsKeys } from "./query_keys";

export const useAuditEngagementsInvalidate = () => {
  const cache = useQueryClient();
  return {
    invalidateAuditEngagements: () => cache.invalidateQueries({ queryKey: auditEngagementsKeys.all() }),
    removeAuditEngagementsCache: () => cache.removeQueries({ queryKey: auditEngagementsKeys.all() })
  };
};
